module.exports = __webpack_public_path__ + "static/media/design-project.8630f918.jpg";